
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

interface RecipeUrlInputProps {
  url: string;
  setUrl: (url: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
}

const RecipeUrlInput = ({ url, setUrl, onSubmit, isLoading }: RecipeUrlInputProps) => {
  return (
    <Card className="mb-8 max-w-md mx-auto">
      <CardContent className="pt-6">
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Input
              type="url"
              placeholder="Paste recipe website URL here"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              disabled={isLoading}
            />
          </div>
          <Button 
            type="submit" 
            className="w-full bg-recipe hover:bg-recipe-dark text-recipe-foreground" 
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="flex items-center">
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Processing...
              </span>
            ) : "Extract Recipe with AI"}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default RecipeUrlInput;
